import type { AxiosResponse } from 'axios';
import api from 'src/services/api';
import * as utils from './apiUtils';
import type {
  JunkaiTenkenIndexParams,
} from 'src/models/apis/extJunkaiTenkenReportTenkenData/extJunkaiTenkenReportTenkenDataRequest';
import {
  type JunkaiTenkenIndexResponse,
  type JunkaiTenkenMasterResponse,
  toTenkenData,
  toTenkenMaster,
} from 'src/models/apis/extJunkaiTenkenReportTenkenData/extJunkaiTenkenReportTenkenDataResponse';
import type { TenkenData, TenkenMaster } from 'src/models/extJunkaiTenkenReportTenkenData';

export default {
  async index(params: JunkaiTenkenIndexParams): Promise<TenkenData[]> {
    const response = await api.get<JunkaiTenkenIndexResponse>(utils.getApiUrl('/ext/junkai-tenken-report/tenken_data'), {
      params,
    });
    return response.data.map(toTenkenData);
  },
  getImage(id: string): Promise<AxiosResponse<Blob>> {
    return api.get(utils.getApiUrl(`/ext/junkai-tenken-report/image/${id}`), {
      responseType: 'blob',
    });
  },
  async getTenkenMaster(): Promise<TenkenMaster> {
    const response = await api.get<JunkaiTenkenMasterResponse>(utils.getApiUrl('/ext/junkai-tenken-report/tenken_master'));
    return toTenkenMaster(response.data);
  },
};
